import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import Title from "../../components/title";
import Project from "./project";

const Projects = () => {
  const [projects, setProjects] = useState([]);

  const topProjects = projects.slice(0, 3);
  const moreProjects = projects.slice(3, projects.length);
  console.log(topProjects, moreProjects);

  useEffect(() => {
    fetch("/db.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  return (
    <Box sx={{ mt: 5 }}>
      <Title title="Top Projects" />
      <Box sx={{ mt: 4 }} className='flex justify-center'>
        <Grid container>
          {topProjects.map((project) => (
            <Project key={project.id} project={project} />
          ))}
        </Grid>
      </Box>
      <Box className="mt-10">
        <Title title="More Projects" />
        <Box sx={{ mt: 5 }}>
          <Grid container>
            {moreProjects.map((project) => (
              <Project key={project.id} project={project} />
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default Projects;
